import React, {useContext, useEffect, useState, useRef} from 'react';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';
import Button from '@material-ui/core/Button';
import {useCommonStyles} from '../../Styles';
import {
    defDateFormat,
    empty,
    req_cust,
    req_stock,
    req_salesman,
    req_delete_file,
    req_report_itemdistributionanalysisbyagent,
    req_report_itemdistributionanalysisreport,
    req_report_itemdistributionanalysisbyagent_alt,
    req_report_itemdistributionanalysisbyagentreport,
    req_report_itemdistributionanalysisbyagentreport_alt,
    req_cust_category,
    req_module_setting
} from '../../Helper/Constants';
import _ from 'lodash';
import JString from '@easytech-international-sdn-bhd/jstring';
import API_Service, {axiosDefaultConfig, axiosURIencode} from '../../Services/API_Service';
import {useSnackbar} from 'notistack';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import DateRangePickerModal from '../../Components/DateRangePickerModal';
import moment from 'moment';
import VirtualListCB from '../../Components/VirtualListCB';
import format from 'date-fns/format';
import {de, getSetting} from '../../Helper/Helper';
import useColumnPreference from '../../Services/useColumnPreference';
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow, TableHead, CircularProgress, TextField, InputAdornment, Tabs, Tab, Select, MenuItem, FormControl, Switch, FormControlLabel, Grid } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import MUIDataTable from 'mui-datatables';
import {IconButton, Tooltip} from '@material-ui/core';
import {Assessment as AssessmentIcon} from '@material-ui/icons';

// 表格尺寸常量 - 移到这里以便在CSS中使用
const TABLE_DIMENSIONS = {
	HEADER_HEIGHT: 30, // MUIDataTable表头高度
	ROW_HEIGHT: 30,    // 表格行高度
	FIXED_ROWS_COUNT: 2 // 需要固定的行数
};

const useStyles = makeStyles((theme) => ({
    viewInRow: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'left',
		marginTop: theme.spacing(1),
		rowGap: 10
	},
	container: {
        maxHeight: '78vh',
        maxWidth: '92vw',
    },
    boldText: {
        fontWeight: 'bold',
    },
    tableHeadRow: {
        backgroundColor: '#424242',
		fontSize: 10,
		padding: 0,
		margin: 0
    },
	tableCellAutoWidth: {
		whiteSpace: "nowrap", 
		overflow: "hidden",
		fontSize: 12,
		padding: 0,
		margin: 0
	},
	table : {
		fontSize: 12,
		borderCollapse: 'separate',
    	borderSpacing: '4px 0px'
	},
	customDatePicker: {
		"& .MuiOutlinedInput-root" : {
			height: "100%",
		},
		"& .MuiOutlinedInput-root .MuiOutlinedInput-input": {
			padding: "5px 15px",
			fontSize: 12,
			textAlign: "center",
		},
		width: 300,
		marginRight: 10,
		fontSize: 12,
	},
	// 自定义滚动条样式
	customScrollContainer: {
		// 针对Webkit浏览器 (Chrome, Safari, Edge)
		'&::-webkit-scrollbar': {
			height: 12,
			width: 12,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#2d2d2d',
			borderRadius: 6,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#555555',
			borderRadius: 6,
			border: '2px solid #2d2d2d',
			'&:hover': {
				backgroundColor: '#777777',
			},
		},
		'&::-webkit-scrollbar-corner': {
			backgroundColor: '#2d2d2d',
		},
		// 针对Firefox
		scrollbarWidth: 'thin',
		scrollbarColor: '#555555 #2d2d2d',
		
		// 确保MUIDataTable内部的表格容器支持sticky positioning
		'& .MuiPaper-root': {
			backgroundColor: '#424242',
		},
		'& .MuiTableContainer-root': {
			position: 'relative',
		},
		// 确保表格本身不会覆盖sticky样式并消除空隙
		'& table': {
			borderCollapse: 'separate',
			borderSpacing: '0', // 消除行间空隙
		},
		// 确保表格行的高度一致
		'& .MuiTableBody-root tr': {
			height: `${TABLE_DIMENSIONS.ROW_HEIGHT}px !important`,
		},
		'& .MuiTableBody-root td': {
			padding: '8px 16px',
			borderBottom: 'none', // 移除默认边框，避免与sticky样式冲突
		}
	},
}));

// 创建冻结列配置的通用函数（前2列）
const createStickyColumnConfig = (columnName, label, leftPosition, width = '150px') => ({
	name: columnName,
	label: label,
	options: {
		display: true,
		setCellProps: (value, rowIndex) => {
			// 前2行是汇总行，需要同时固定行和列
			const isFixedRow = rowIndex < TABLE_DIMENSIONS.FIXED_ROWS_COUNT;
			if (isFixedRow) {
				return {
					style: {
						position: 'sticky',
						left: leftPosition,
						top: rowIndex === 0 ? TABLE_DIMENSIONS.HEADER_HEIGHT : TABLE_DIMENSIONS.HEADER_HEIGHT + TABLE_DIMENSIONS.ROW_HEIGHT,
						zIndex: 1300, // 最高层级，因为同时固定行和列
						backgroundColor: '#424242',
						color: '#e0e0e0',
						fontWeight: 'bold',
						minWidth: width,
						maxWidth: width,
						width: width,
						borderBottom: '1px solid #555',
						height: TABLE_DIMENSIONS.ROW_HEIGHT,
						lineHeight: `${TABLE_DIMENSIONS.ROW_HEIGHT}px`
					}
				};
			}
			// 非汇总行只固定列
			return {
				style: {
					position: 'sticky',
					left: leftPosition,
					zIndex: 1000,
					backgroundColor: '#424242',
					color: '#e0e0e0',
					minWidth: width,
					maxWidth: width,
					width: width
				}
			};
		},
		setCellHeaderProps: () => ({
			style: {
				position: 'sticky',
				left: leftPosition,
				zIndex: 1100,
				backgroundColor: '#424242',
				color: 'white',
				// borderRight: leftPosition === 150 ? '2px solid #666' : '1px solid #555',
				minWidth: width,
				maxWidth: width,
				width: width
			}
		})
	}
});

// 创建基础冻结列数组（只有前2列）
const createBaseStickyColumns = () => [
	createStickyColumnConfig("product_code", "Product Code", 0, '150px'),
	createStickyColumnConfig("product_name", "Product Name", 150, '200px')
];

// 创建固定行样式的通用函数（用于非冻结列）
const createRowStickyStyle = (rowIndex) => {
	if (rowIndex < TABLE_DIMENSIONS.FIXED_ROWS_COUNT) {
		return {
			position: 'sticky',
			top: rowIndex === 0 ? TABLE_DIMENSIONS.HEADER_HEIGHT : TABLE_DIMENSIONS.HEADER_HEIGHT + TABLE_DIMENSIONS.ROW_HEIGHT,
			zIndex: 1200, // 固定行的层级
			backgroundColor: '#424242',
			color: '#e0e0e0',
			fontWeight: 'bold',
			borderBottom: '1px solid #555',
			height: TABLE_DIMENSIONS.ROW_HEIGHT,
			lineHeight: `${TABLE_DIMENSIONS.ROW_HEIGHT}px`
		};
	}
	return {};
};

export default function RItemDistAnalysis() {
    const classes = useStyles();
    const commonStyle = useCommonStyles();
    const [gState, setGState] = useContext(AppContext);
	var {translation: language, client} = gState;
	
	// 动态宽度和高度管理
	const containerRef = useRef(null);
	const [containerWidth, setContainerWidth] = useState('calc(100vw - 320px)');
	const [containerHeight, setContainerHeight] = useState('calc(100vh - 300px)');
	
	// 检测导航栏状态并调整宽度和高度
	useEffect(() => {
		const updateDimensions = () => {
			// 检测drawer是否打开 - 计算宽度
			const drawer = document.querySelector('.MuiDrawer-root');
			if (drawer) {
				const drawerRect = drawer.getBoundingClientRect();
				const isDrawerOpen = drawerRect.width > 100; // 275px为完全打开，60-70px为关闭状态
				
				if (isDrawerOpen) {
					setContainerWidth('calc(100vw - 320px)'); // 导航栏打开
				} else {
					setContainerWidth('calc(100vw - 120px)'); // 导航栏关闭，留少量边距
				}
			}
			
			// 计算高度 - 动态计算页面各部分占用的高度
			let totalOffset = 0;
			
			// 顶部应用栏
			const appBar = document.querySelector('.MuiAppBar-root');
			if (appBar) {
				totalOffset += appBar.offsetHeight;
			}
			
			// 筛选器行
			const filterRow = document.querySelector('[class*="viewInRow"]');
			if (filterRow) {
				totalOffset += filterRow.offsetHeight + 20; // 减少边距
			}
			
			// 表格标题和工具栏的预估高度（更精确）
			const tableHeaderOffset = 60;
			totalOffset += tableHeaderOffset;
			
			// 底部分页器和边距（最小化）
			const bottomOffset = 20;
			totalOffset += bottomOffset;
			
			// 计算最终高度，确保最小高度
			const minHeight = 400;
			const calculatedHeight = Math.max(window.innerHeight - totalOffset, minHeight);
			setContainerHeight(`${calculatedHeight}px`);
		};
		
		// 初始检测（延迟确保DOM完全渲染）
		setTimeout(updateDimensions, 100);
		
		// 监听窗口大小变化
		window.addEventListener('resize', updateDimensions);
		
		// 监听DOM变化（导航栏开关、内容变化）
		const observer = new MutationObserver(() => {
			setTimeout(updateDimensions, 300); // 延迟等待动画完成
		});
		
		const targetNode = document.body;
		observer.observe(targetNode, {
			attributes: true,
			subtree: true,
			attributeFilter: ['class']
		});
		
		return () => {
			window.removeEventListener('resize', updateDimensions);
			observer.disconnect();
		};
	}, []);
	
    const singleton = PersistantData.getInstance();
	if (typeof (language) === 'undefined') {
		language = singleton.getlang()
	}
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();
    const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	}

    const [splist, setSPlist] = useState([]);
	const [outletList, setOutletList] = useState([]);
    const [outletCategoryList, setOutletCategoryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [itemList, setItemList] = useState([]);

    const [spView, setSpView] = useState(false);
	const [spSelectedValue, setSpSelectedValue] = useState(empty);
	const [spSelectedName, setSpSelectedName] = useState(empty);

	const [outletView, setOutletView] = useState(false);
	const [outletSelectedName, setOutletSelectedName] = useState(empty);
	const [outletSelectedValue, setOutletSelectedValue] = useState(empty);

    const [categoryListView, setCategoryListView] = useState(false);
    const [categorySelectedName, setCategorySelectedName] = useState(empty);
    const [categorySelectedValue, setCategorySelectedValue] = useState(empty);

    const [productListView, setProductListView] = useState(false);
    const [selectedProductName, setSelectedProductName] = useState(empty);
    const [selectedProductValue, setSelectedProductValue] = useState(empty);

    const [stateListView, setStateListView] = useState(false);
    const [selectedStateValue, setSelectedStateValue] = useState(empty);
	const [selectedStateName, setSelectedStateName] = useState(empty);

    const [outletVisitDateRange, setOutletVisitDateRange] = useState({});
    const [openOutletVisitDateDoc, setOpenOutletVisitDateDoc] = useState(false);

    const [loading, setLoading] = useState(false);
    const [tableHeader, setTableHeader] = useState([]);
    const [reportData, setReportData] = useState([]);
    
    // Toggle state for the table
    const [toggleState, setToggleState] = useState(false);
    
    // New state variables for alternative API table
    const [tableHeaderAlt, setTableHeaderAlt] = useState([]);
    const [reportDataAlt, setReportDataAlt] = useState([]);

    const { columns: preferredColumns1, onColumnViewChange: onPrefColumnViewChange1 } = useColumnPreference('RItemDistByAgent_1', tableHeader, client);
    const { columns: preferredColumns2, onColumnViewChange: onPrefColumnViewChange2 } = useColumnPreference('RItemDistByAgent_2', tableHeaderAlt, client);

    const handleToggleChange = () => {
        setToggleState(!toggleState);
    };

    const getOutletVisitDate = () => {
		return !_.isEmpty(outletVisitDateRange) ? moment(outletVisitDateRange.startDate).format('DD MMMM YYYY') + " / " + moment(outletVisitDateRange.endDate).format('DD MMMM YYYY') : moment(new Date()).format('DD MMMM YYYY') + " / " + moment(new Date()).format('DD MMMM YYYY');
	}

    useEffect(() => {
		if (JString(gState.client).isValid()) {
            loadModule(gState.client);
            // getSalesmanList(gState.client);
			getOutletList(gState.client);
            getOutletCategory(gState.client);
            loadStocksList(gState.client);
		}
	}, [gState.client]);

    const loadModule = (_client = client) => {
        API_Service.get(req_module_setting, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				const country = getSetting(extraData, 'country');
				let country_arr = [JSON.parse(JSON.stringify(country))];
				var status = country_arr[0].states;
				var _status = [];
				for (let i = 0; i < status?.length; i++) {
					const {name} = status[i];
					_status.push({name: name, secondary: name, value: name, status: 1});
				}
				setStateList(_status);
			} else {
				snack(language.not_found_salesperson, 'warning');
			}
		});
    }

    const getSalesmanList = (_client = client) => {
		API_Service.get(req_salesman, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					const {name, login_id, login} = extraData[idx];
					_data.push({name: name, secondary: login, value: login_id});
				}
				setSPlist(splist => (_data));
			} else {
				snack(gState.translation.not_found_salesperson, 'warning');
			}
		});
	}

	const getOutletList = (_client = client) => {
		API_Service.get(req_cust, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			var {customer, inactive_customer} = extraData;
			if (parseInt(result) === 1) {
				var arr = [];
				for (let i = 0; i < customer.length; i++) {
					const {cust_id, cust_code, cust_company_name} = customer[i];
					arr.push({
						name: cust_company_name,
						secondary: cust_code,
						value: cust_id,
                        status: 1
					});
				}
                for (let i = 0; i < inactive_customer.length; i++) {
					const {cust_id, cust_code, cust_company_name} = inactive_customer[i];
					arr.push({
						name: cust_company_name,
						secondary: cust_code,
						value: cust_id,
						status: 0
                    });
                }
				setOutletList(arr);
			}
		});
	}

    const getOutletCategory = (_client = client) => {
        API_Service.get(req_cust_category, axiosDefaultConfig(_client)).then(({data}) => {
			if (data) {
				var {result, extraData } = data;

				result = JString(result).toNumber();
				if (result === 1) {
					var _data = [];
					for (let i = 0; i < extraData.length; i++) {
						const {cust_category_name, cust_category_code, cust_category_id, cust_category_status} = extraData[i];
						if (parseInt(cust_category_status) === 1) {
							_data.push({
                                name: cust_category_name,
                                secondary: cust_category_code,
                                value: cust_category_id,
                                status: 1
                            });
						} else {
							_data.push({
                                name: cust_category_name,
                                secondary: cust_category_code,
                                value: cust_category_id,
                                status: 0
                            });
						}
					}
					setOutletCategoryList(()=>(_data));
				}
			}
		}).catch(err => de(err.message, 'customer category list'));
    }

    const loadStocksList = (_client = client) => {
		var req = `${req_stock}-1`;
		API_Service.get(req, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			const {stock: stockApi} = extraData;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < stockApi.length; idx++) {
					const {product_name, product_code, product_status} = stockApi[idx];
					_data.push({name: product_name, secondary: product_code, value: product_code, status: parseInt(product_status)});
				}
				setItemList(itemList => (_data));
			}
		});
	}

    const OutletVisitSPViewClose = (newValue) => {
		setSpView(false);
		if (newValue) {
			var spvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spvalue += newValue[i].value;
				} else {
					spvalue += newValue[i].value + ",";
				}
			}
			setSpSelectedValue(spvalue);

			var spname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spname += newValue[i].name;
				} else {
					spname += newValue[i].name + ",";
				}
			}
			setSpSelectedName(spname);
		}
	}

	const OutletVisitOutletViewClose = (newValue) => {
		setOutletView(false);
		if (newValue) {
			var custvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					custvalue += newValue[i].value;
				} else {
					custvalue += newValue[i].value + ",";
				}
			}
			setOutletSelectedValue(custvalue);

			var custname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					custname += newValue[i].name;
				} else {
					custname += newValue[i].name + ",";
				}
			}
			setOutletSelectedName(custname);
		}
	}

    const CategoryViewClose = (newValue) => {
        setCategoryListView(false);
        if (newValue) {
			var value = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
				} else {
					value += newValue[i].value + ",";
				}
			}
			setCategorySelectedValue(value);

			var name = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					name += newValue[i].name;
				} else {
					name += newValue[i].name + ",";
				}
			}
			setCategorySelectedName(name);
		}
    }

    const StateViewClose = (newValue) => {
		setStateListView(false);
		if (newValue) {
			var statevalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					statevalue += newValue[i].value;
				} else {
					statevalue += newValue[i].value + ",";
				}
			}
			setSelectedStateValue(statevalue);

			var statename = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					statename += newValue[i].name;
				} else {
					statename += newValue[i].name + ",";
				}
			}
			setSelectedStateName(statename);
		}
	}

    const ProductViewClose = (newValue) => {
		setProductListView(false);
		if (newValue) {
			var itemsvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					itemsvalue += newValue[i].value;
				} else {
					itemsvalue += newValue[i].value + ",";
				}
			}
			setSelectedProductValue(itemsvalue);

			var itemsname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					itemsname += newValue[i].name;
				} else {
					itemsname += newValue[i].name + ",";
				}
			}
			setSelectedProductName(itemsname);
		}
	}

    const getReportData = (_client = client) => {
        setLoading(true);
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(outletVisitDateRange)) {
			st_date = format(outletVisitDateRange.startDate, defDateFormat);
			st_date_to = format(outletVisitDateRange.endDate, defDateFormat);
		}
        var parameters = {
            date_from: st_date,
            date_to: st_date_to,
            salespersonId: spSelectedValue,
            cust_id: outletSelectedValue,
            cust_category_id: categorySelectedValue,
            cust_state: selectedStateValue,
            product_code: selectedProductValue
        };
        const param = axiosURIencode(parameters);
        const table_head = [];

		API_Service.get(`${req_report_itemdistributionanalysisbyagent}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
                const {data, header} = extraData;
                setReportData(data);
                const reversedHeader = [...header].reverse();
                for (let x = 0; x < reversedHeader.length; x++) {
					// 判断是否为前2列，应用冻结列配置
					let columnConfig;
					if (reversedHeader[x] === "product_code") {
						columnConfig = createStickyColumnConfig("product_code", "Product Code", 0, '150px');
					} else if (reversedHeader[x] === "product_name") {
						columnConfig = createStickyColumnConfig("product_name", "Product Name", 150, '200px');
					} else {
						columnConfig = {
							name: reversedHeader[x],
							label: reversedHeader[x] == "product_name" ? "Product Name" : reversedHeader[x] == "product_code" ? "Product Code" : reversedHeader[x],
							options: {
								display: true,
								setCellProps: (value, rowIndex) => ({
									style: createRowStickyStyle(rowIndex)
								})
							}
						};
					}
                    table_head.splice(0, 0, columnConfig);
                }
                setTableHeader(table_head);

			} else {
                setReportData([]);
                setTableHeader([]);
                snack(language.no_data, 'warning');
            }
            setLoading(false);
		});
		
		// Also call the alternative API
		getReportDataAlt(_client);
	}

    const getReportDataAlt = (_client = client) => {
        setLoading(true);
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(outletVisitDateRange)) {
			st_date = format(outletVisitDateRange.startDate, defDateFormat);
			st_date_to = format(outletVisitDateRange.endDate, defDateFormat);
		}
        var parameters = {
            date_from: st_date,
            date_to: st_date_to,
            salespersonId: spSelectedValue,
            cust_id: outletSelectedValue,
            cust_category_id: categorySelectedValue,
            cust_state: selectedStateValue,
            product_code: selectedProductValue
        };
        const param = axiosURIencode(parameters);
        const table_head_alt = [];

		API_Service.get(`${req_report_itemdistributionanalysisbyagent_alt}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
                const {data, header} = extraData;
                setReportDataAlt(data);
                const reversedHeader = [...header].reverse();
                for (let x = 0; x < reversedHeader.length; x++) {
					// 判断是否为前2列，应用冻结列配置
					let columnConfig;
					if (reversedHeader[x] === "product_code") {
						columnConfig = createStickyColumnConfig("product_code", "Product Code", 0, '150px');
					} else if (reversedHeader[x] === "product_name") {
						columnConfig = createStickyColumnConfig("product_name", "Product Name", 150, '200px');
					} else {
						columnConfig = {
							name: reversedHeader[x],
							label: reversedHeader[x] == "product_name" ? "Product Name" : reversedHeader[x] == "product_code" ? "Product Code" : reversedHeader[x],
							options: {
								display: true,
								setCellProps: (value, rowIndex) => ({
									style: createRowStickyStyle(rowIndex)
								})
							}
						};
					}
                    table_head_alt.splice(0, 0, columnConfig);
                }
                setTableHeaderAlt(table_head_alt);

			} else {
                setReportDataAlt([]);
                setTableHeaderAlt([]);
                snack(language.no_data, 'warning');
            }
            setLoading(false);
		});
	}

	const onGenerateReport = (_client = client) => {
		setLoading(true);
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(outletVisitDateRange)) {
			st_date = format(outletVisitDateRange.startDate, defDateFormat);
			st_date_to = format(outletVisitDateRange.endDate, defDateFormat);
		}
		var parameters = {
			date_from: st_date,
			date_to: st_date_to,
			salespersonId: spSelectedValue,
			cust_id: outletSelectedValue,
			cust_category_id: categorySelectedValue,
			cust_state: selectedStateValue,
			product_code: selectedProductValue
		};
		const param = axiosURIencode(parameters);

		API_Service.get(`${req_report_itemdistributionanalysisbyagentreport}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				window.open(extraData.url, '_blank');
				const delay = setTimeout(() => {
					API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
					clearTimeout(delay);
				}, 5000);
			} else {
				snack(language.no_data, 'warning');
			}
			setLoading(false);
		});
	}

	const onGenerateReportAlt = (_client = client) => {
		setLoading(true);
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(outletVisitDateRange)) {
			st_date = format(outletVisitDateRange.startDate, defDateFormat);
			st_date_to = format(outletVisitDateRange.endDate, defDateFormat);
		}
		var parameters = {
			date_from: st_date,
			date_to: st_date_to,
			salespersonId: spSelectedValue,
			cust_id: outletSelectedValue,
			cust_category_id: categorySelectedValue,
			cust_state: selectedStateValue,
			product_code: selectedProductValue
		};
		const param = axiosURIencode(parameters);

		API_Service.get(`${req_report_itemdistributionanalysisbyagentreport_alt}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				window.open(extraData.url, '_blank');
				const delay = setTimeout(() => {
					API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
					clearTimeout(delay);
				}, 5000);
			} else {
				snack(language.no_data, 'warning');
			}
			setLoading(false);
		});
	}

	return (
		<div style={{height: '100%'}}>
            <div className={classes.viewInRow}>
				{/* <Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setSpView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{spSelectedName ? _.truncate(spSelectedName, {length: 20}) : language.salesperson}
					</Typography>
				</Button> */}
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setOutletView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{outletSelectedName ? _.truncate(outletSelectedName, {length: 20}) : language.customer}
					</Typography>
				</Button>
                <Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setCategoryListView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{categorySelectedName ? _.truncate(categorySelectedName, {length: 20}) : language.category}
					</Typography>
				</Button>
                <Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setStateListView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedStateName ? _.truncate(selectedStateName, {length: 20}) : language.state}
					</Typography>
				</Button>
                <Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setProductListView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedProductName ? _.truncate(selectedProductName, {length: 20}) : language.items}
					</Typography>
				</Button>
                <Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setOpenOutletVisitDateDoc(true)}>
					<Typography className={commonStyle.searchBtnFont}>
						{getOutletVisitDate()}
					</Typography>
				</Button>
				<Button
					style={{marginRight: 10}}
					size="small"
					color="primary"
					variant={'contained'}
					onClick={() => (getReportData(), getReportDataAlt())}
					disabled={loading ? true : false}>
					<Typography className={commonStyle.searchBtnFont}>{language.view}</Typography>
					{
						loading ? <CircularProgress size={20}/> : ''
					}
				</Button>
			</div>
			<div style={{height: 20}}/>
			{
                reportData.length > 0 && toggleState == false && (
                    <div 
						ref={containerRef}
						className={classes.customScrollContainer}
						style={{
							width: '100%',
							maxWidth: containerWidth,
							minWidth: '600px',
							height: containerHeight,
							maxHeight: containerHeight,
							overflowX: 'auto',
							overflowY: 'auto'
						}}>
						<div style={{minWidth: 'max-content'}}>
							<MUIDataTable
								title={language.item_distribution_analysis_by_agent + " (Based on Total Outlet Visited)"}
								data={reportData}
								columns={preferredColumns1}
								options={{
									search: false,
									print: false,
									filter: false,
									download: false,
									selectableRows: 'none',
									rowsPerPage: 100,
									rowsPerPageOptions: [100, 200, 300, 400],
									responsive: 'standard',
									pagination: true,
									tableBodyMaxHeight: `calc(${containerHeight} - 80px)`,
									onColumnViewChange: onPrefColumnViewChange1,
									customSort: (data, colIndex, order) => {
										// 复制数据以避免直接修改原始数据
										const sortedData = [...data];
										// 提取前两行（摘要行）
										const summaryRows = sortedData.slice(0, 2);
										// 提取需要排序的数据行（除了前两行）
										const dataToSort = sortedData.slice(2);
										
										// 对数据行进行排序
										dataToSort.sort((a, b) => {
											// 获取需要比较的值
											let aVal = a.data[colIndex];
											let bVal = b.data[colIndex];
											
											// 如果是百分比字段，提取数字部分
											if (typeof aVal === 'string' && aVal.includes('%')) {
												aVal = parseFloat(aVal);
											}
											if (typeof bVal === 'string' && bVal.includes('%')) {
												bVal = parseFloat(bVal);
											}
											
											// 处理数字比较
											if (!isNaN(aVal) && !isNaN(bVal)) {
												return (order === 'asc' ? aVal - bVal : bVal - aVal);
											}
											
											// 字符串比较
											return (
												order === 'asc'
													? aVal < bVal ? -1 : aVal > bVal ? 1 : 0
													: aVal < bVal ? 1 : aVal > bVal ? -1 : 0
											);
										});
										
										// 将摘要行与排序后的数据行重新合并
										return [...summaryRows, ...dataToSort];
									},
									setTableProps: () => ({size: 'small'}),
									customToolbar: () =>
										<Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{marginTop: -57, paddingRight: 60}}>
											<Grid item style={{marginTop: 4}}>
												<FormControlLabel
													control={
														<Switch
															checked={toggleState}
															onClick={handleToggleChange}
															color="primary"
														/>
													}
													label="Total Outlet Visited"
													labelPlacement="start"
												/>
											</Grid>

											<Grid item>
												<CheckinTableReportButton onGenerateReport={onGenerateReport}/>
											</Grid>
										</Grid>
								}}
							/>
						</div>
					</div>
                )
            }
            
            {/* Alternative API Table - shown when toggleState is true */}
            {
                reportDataAlt.length > 0 && toggleState == true && (
                    <div 
						className={classes.customScrollContainer}
						style={{
							width: '100%',
							maxWidth: containerWidth,
							minWidth: '600px',
							height: containerHeight,
							maxHeight: containerHeight,
							overflowX: 'auto',
							overflowY: 'auto'
						}}>
						<div style={{minWidth: 'max-content'}}>
							<MUIDataTable
								title={language.item_distribution_analysis_by_agent + " (Based on Total Outlet Assigned)"}
								data={reportDataAlt}
								columns={preferredColumns2}
								options={{
									search: false,
									print: false,
									filter: false,
									download: false,
									selectableRows: 'none',
									rowsPerPage: 100,
									rowsPerPageOptions: [100, 200, 300, 400],
									responsive: 'standard',
									pagination: true,
									tableBodyMaxHeight: `calc(${containerHeight} - 80px)`,
									onColumnViewChange: onPrefColumnViewChange2,
									customSort: (data, colIndex, order) => {
										// 复制数据以避免直接修改原始数据
										const sortedData = [...data];
										// 提取前两行（摘要行）
										const summaryRows = sortedData.slice(0, 2);
										// 提取需要排序的数据行（除了前两行）
										const dataToSort = sortedData.slice(2);
										
										// 对数据行进行排序
										dataToSort.sort((a, b) => {
											// 获取需要比较的值
											let aVal = a.data[colIndex];
											let bVal = b.data[colIndex];
											
											// 如果是百分比字段，提取数字部分
											if (typeof aVal === 'string' && aVal.includes('%')) {
												aVal = parseFloat(aVal);
											}
											if (typeof bVal === 'string' && bVal.includes('%')) {
												bVal = parseFloat(bVal);
											}
											
											// 处理数字比较
											if (!isNaN(aVal) && !isNaN(bVal)) {
												return (order === 'asc' ? aVal - bVal : bVal - aVal);
											}
											
											// 字符串比较
											return (
												order === 'asc'
													? aVal < bVal ? -1 : aVal > bVal ? 1 : 0
													: aVal < bVal ? 1 : aVal > bVal ? -1 : 0
											);
										});
										
										// 将摘要行与排序后的数据行重新合并
										return [...summaryRows, ...dataToSort];
									},
									setTableProps: () => ({size: 'small'}),
									customToolbar: () =>
										<Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{marginTop: -57, paddingRight: 60}}>
											<Grid item style={{marginTop: 4}}>
												<FormControlLabel
													control={
														<Switch
															checked={toggleState}
															onClick={handleToggleChange}
															color="primary"
														/>
													}
													label="Total Outlet Assigned"
													labelPlacement="start"
												/>
											</Grid>

											<Grid item>
												<CheckinTableReportButton onGenerateReport={onGenerateReportAlt}/>
											</Grid>
										</Grid>
								}}
							/>
						</div>
					</div>
                )
            }
            <VirtualListCB
				open={spView}
				setClose={data => OutletVisitSPViewClose(data)}
				title={language.salesperson}
				data={splist}
				language={language}
			/>

			<VirtualListCB
				open={outletView}
				setClose={data => OutletVisitOutletViewClose(data)}
				title={"Outlet"}
				data={outletList}
				language={language}
                filteration={1}
			/>

            <VirtualListCB
				open={categoryListView}
				setClose={data => CategoryViewClose(data)}
				title={"Outlet Category"}
				data={outletCategoryList}
				language={language}
                filteration={1}
			/>

            <VirtualListCB
				open={stateListView}
				setClose={data => StateViewClose(data)}
				title={"State"}
				data={stateList}
				language={language}
				filteration={0}
			/>

            <VirtualListCB
				open={productListView}
				setClose={data => ProductViewClose(data)}
				title={"Product"}
				data={itemList}
				language={language}
				filteration={1}
			/>

			<DateRangePickerModal
				setPositive={range => {
					setOutletVisitDateRange(range);
					setOpenOutletVisitDateDoc(false)
				}}
				setNegative={() => {
					setOpenOutletVisitDateDoc(false)
				}}
				setClose={() => {
					setOpenOutletVisitDateDoc(false)
				}}
                // limit={6}
				open={openOutletVisitDateDoc}
				message={language.date_range}
				positive={language.ok}
				negative={language.cancel}
			/>
		</div>
	)
}

function CheckinTableReportButton({onGenerateReport}) {
	return (
		<React.Fragment>
			<Tooltip title={'Generate Report'}>
				<IconButton
					edge={'end'}
					color={'primary'}
					onClick={() => onGenerateReport()} aria-label="addnew">
					<AssessmentIcon/>
				</IconButton>
			</Tooltip>
		</React.Fragment>
	)
}